import {Tooltip} from 'platform/components';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getTooltipProps} from '../../utils/getTooltipProps';

type PlainCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};

export function PlainCellRenderer(props: PlainCellRendererProps) {
  const className = getCellClassName(props.column);
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      <div className={className}>{props.value}</div>
    </Tooltip>
  );
}
